<template>

<v-dialog v-model="dialog" width="700px">
  <v-card>
    <p class=".title ma-2">Send NEW Documents to the Guest. ( It may take a few minutes before the mails are send )</p>
    <v-form ref="huovSendDocuGuest">

    
    <v-textarea v-model="huov.mail_text" :rows="5" :label="huov.mail_text_label"></v-textarea>

    <v-simple-table>
      <template v-slot:default>
       <tbody>
        <tr v-for="(docu,i) in huov.docu" :key="i"> 
          <td>
            <v-checkbox v-model="docu.docu_selected" :label="docu.docu_oms"></v-checkbox>
          </td> 
        </tr>
       </tbody>
      </template>
    </v-simple-table>  


    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary mx-2"  small @click="updSendDocuGuest">Send document(s)</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      huov: {},
      huov_aant_volwRules: [
          v => (v && parseInt(v) >= 1) || "Number of Adults minimal 1"
      ]
    }
  },
  methods: {
    open(huov_encrid) {

      this.huov = {};

      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/getHuovSendDocuGuest.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovSendDocuGuest"
          },
          getHuovSendDocuGuest: {
            huov_encrid: huov_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovSendDocuGuest;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updSendDocuGuest() { 
      this.$axios
        .post("ares/json/ares/huov/updSendDocuGuest.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "updSendDocuGuest"
          },
          updSendDocuGuest: {
            huov_encrid: this.huov.huov_encrid,
            mail_text: this.huov.mail_text,
            docu: this.huov.docu
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {      
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.updSendDocuGuest.text,
              color: res.data.updSendDocuGuest.color
             });
            this.dialog = false;
          }
        })
    },
  }
}
</script>

